import { DataEntry } from '../../../lib/types';
import { getCourseById } from '../../../modules/course/api';
import { Course } from '../../../modules/course/types';

export const getCourseByIdUseCase = async (courseId: number): Promise<DataEntry<Course>> => {
  return getCourseById(courseId);
};